import {QueryKey} from '@tanstack/query-core';
import {useQuery, UseQueryOptions, UseQueryResult} from '@tanstack/react-query';

export function useBaseQuery<
    TQueryFnData = unknown,
    TError = unknown,
    TData = TQueryFnData,
    TQueryKey extends QueryKey = QueryKey,
>(options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>): UseQueryResult<TData, TError> {

    const enabled = options.enabled !== false;

    return useQuery<TQueryFnData, TError, TData, TQueryKey>({
        ...options,
        enabled,
    });
}
